/**
 * Dummy data save for status 4,5,7,8 skip-blocks flow.
 * Each block uses the same insert API as its page (e.g. Block C Fixed Assets → api/blockc/insert-item).
 * Returns array of { apiPath, payload } for blocks 2–10.
 * Payloads match exact shape and types each page sends so backend accepts.
 */
export function getStaticBlockPayload(dslNo, surveyYear) {
  const d = dslNo;
  const y = typeof surveyYear === 'string' ? String(surveyYear).split('-')[0] : surveyYear;
  const yInt = parseInt(y, 10) || 2024;
  const dInt = parseInt(d, 10) || 0;

  // 2. Block C Fixed Assets Data – api/blockc/insert-item (FixedAssets.jsx)
  const blockCDataItem = {
    dslNo: dInt,
    surveyYear: y,
    itemCode: 1,
    assetCode: 140,
    itemName: '',
    blockItem: 'Block-C,Item-1',
    blockType: 'gross',
    grossValueOpening: 0,
    additionRevaluation: 0,
    actualAdditions: 0,
    deductionAdjDuringYear: 0,
    closingAsOn: 0,
    depreciationBeginning: 0,
    depreciationDuringYear: 0,
    adjForSoldDiscardedDuringYear: 0,
    netValueOpening: 0,
    netValueYearEnd: 0,
    netValueClosing: 0,
    tableName: 'Block C',
    statusFlag: '1'
  };

  // 3. Balance Sheet – api/blockd/insert-item (payload format as per API; values 0 for dummy save)
  const blockDDataItem = {
    dsl_no: d,
    survey_year: y,
    code: 14,
    item_name: 'Advance against FDR',
    block_item: 'Block-D, Item-14',
    BLOCK_ID: 'D',
    current_year_value: 0,
    previous_year_value: 0
  };

  // 4. Profit and Loss Account – api/block/insert-item (ProfitAndLossAccount.jsx)
  const blockPLItem = {
    dsl_no: d,
    survey_year: y,
    block_type: 'ASI_BLOCKG',
    item_code: 1,
    asset_code: '',
    item_name: 'Dummy',
    other_item: '',
    BLOCK_ID: 'G',
    BLOCK_ITEM: 'Block-G,Item-1',
    value: 0
  };

  // 5. Block E – api/blockE/insert-bulk (EmploymentAndLabourCost: catagory_id string, category_of_staff from master)
  const blockEDataItem = {
    dsl_no: d,
    survey_year: y,
    catagory_id: '95',
    category_of_staff: 'Part A:',
    manufacturing: 0,
    nonmanufacturing: 0,
    total: 0,
    avg_no_persons_worked: 0,
    no_mandays_paid: 0,
    wages_or_salaries: 0
  };

  // 6. Block H – api/input-items-indigenous/insert (InputItemsIndigenous.jsx)
  const blockHDataItem = {
    dsl_no: d,
    survey_year: y,
    item_code: '9920100',
    item_desc: 'Other basic items(indigenous)',
    unit_of_qty: '',
    qty_consumed: 0,
    purchase_value: 0
  };

  // 7. Block I – api/input-items-directlyItems/insertInputIItems (InputItemsImported.jsx)
  const blockIDataItem = {
    dsl_no: d,
    survey_year: y,
    item_code: '9922100',
    item_desc: 'Other imported items',
    unit_of_qty: '',
    qty_consumed: 0,
    purchase_value: 0
  };

  // 8. Block J – api/input-items-directlyItems/insertInputJItems (ProductsAndByProducts.jsx: item_desc required)
  const blockJDataItem = {
    dsl_no: d,
    survey_year: y,
    item_code: '9921100',
    item_desc: 'Other products/by-products',
    other_item: '',
    unit_of_qty: '',
    qty_manufactured: 0,
    qty_sold: 0,
    gross_sale_value: 0,
    goods_service_tax: 0,
    excise_duty: 0,
    other_distributive_expanse: 0,
    subsidy: 0,
    perunit_net_sale: 0,
    distributive_expenses_total: 0
  };

  // 9. Block KL – api/block/kl/insert (ICTUsageAndEnergyConservation.jsx: dslNo/surveyYear number, itemCode number)
  const blockKLKItem = { dslNo: dInt, surveyYear: yInt, itemCode: 12, value: '0' };
  const blockKLLItem = { dslNo: dInt, surveyYear: yInt, itemCode: 1, value: '0' };

  // 10. Part A-1 – api/input-items-indigenous/InputItemsHAndIPartA (PartA.jsx: only rows with non-empty item sent)
  const partADataItem = {
    dsl_no: d,
    survey_year: y,
    block_no: 'H',
    item_code: '0',
    item_desc: 'Dummy (skip blocks)',
    unit_of_qty: '',
    average_rate_per_unit: '',
    if_high_or_low: ''
  };

  return [
    { apiPath: 'blockc/insert-item', payload: { data: [blockCDataItem], remarks: [] } },
    { apiPath: 'blockd/insert-item', payload: { data: [blockDDataItem], remarks: [], block_type: 'D', block_title: 'Balance Sheet' } },
    { apiPath: 'block/insert-item', payload: { items: [blockPLItem], remarks: [] } },
    { apiPath: 'blockE/insert-bulk', payload: { data: [blockEDataItem], remarks: [] } },
    { apiPath: 'input-items-indigenous/insert', payload: { data: [blockHDataItem], remarks: [] } },
    { apiPath: 'input-items-directlyItems/insertInputIItems', payload: { data: [blockIDataItem], remarks: [] } },
    { apiPath: 'input-items-directlyItems/insertInputJItems', payload: { data: [blockJDataItem], remarks: [] } },
    { apiPath: 'block/kl/insert', payload: { ASI_BLOCKK: [blockKLKItem], ASI_BLOCKL: [blockKLLItem], remarks: [] } },
    { apiPath: 'input-items-indigenous/InputItemsHAndIPartA', payload: { data: [partADataItem], remarks: [] } }
  ];
}

/** @deprecated Use getStaticBlockPayload. Kept for backward compatibility. */
export function getStaticBlockUrls(dslNo, surveyYear) {
  const payloads = getStaticBlockPayload(dslNo, surveyYear);
  return payloads.map((p, i) => ({ name: p.apiPath.replace('/', '_'), postData: p.payload }));
}
